import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';

export const useFetchTouPricingList = (operatorId, year) => {
  return useQuery({
    queryKey: ['touPricingList', operatorId, year],
    queryFn: async () => {
      const response = await httpService.get(
        `/tou-pricing/list?operatorId=${operatorId}&year=${year}`,
      );
      return response.data.data;
    },
    enabled: !!operatorId && !!year,
    refetchOnWindowFocus: false,
  });
};

export const useFetchTouPricingDetail = (operatorId, year, month, enabled) => {
  return useQuery({
    queryKey: ['touPricingDetail', operatorId, year, month],
    queryFn: async () => {
      const response = await httpService.get(
        `/tou-pricing/detail?operatorId=${operatorId}&year=${year}&month=${month}`,
      );
      return response.data.data;
    },
    enabled: !!operatorId && !!year && !!month && !!enabled,
    refetchOnWindowFocus: false,
  });
};

export const useUpsertTouPricing = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body) => {
      const response = await httpService.post('/tou-pricing/upsert', body);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['touPricingList'] });
      queryClient.invalidateQueries({ queryKey: ['touPricingDetail'] });
      queryClient.invalidateQueries({ queryKey: ['touPricingApplicable'] });
    },
  });
};

export const useCopyTouPricing = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body) => {
      const response = await httpService.post('/tou-pricing/copy', body);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['touPricingList'] });
    },
  });
};

export const useFetchTouApplicable = (operatorId, from, to) => {
  return useQuery({
    queryKey: ['touPricingApplicable', operatorId, from, to],
    queryFn: async () => {
      const response = await httpService.get(
        `/tou-pricing/applicable?operatorId=${operatorId}&from=${from}&to=${to}`,
      );
      return response.data.data;
    },
    enabled: !!operatorId && !!from && !!to,
    refetchOnWindowFocus: false,
  });
};
